module.exports = __webpack_public_path__ + "img/ic_unlogin_logo.4cf02523.jpg";